import { PlusIcon } from '@heroicons/react/16/solid'
import 'swiper/css';

const tiers = [
  {
    name: 'PANAMA',
    img: '/Trips/PANAMA.jfif',
    description: 'Entre rascacielos y gigantes del mar, Panamá sorprende.',
    priceMonthly: 'Q4,936',
    href: '#',
    highlights: [
      { description: 'Boletos aéreos ida y vuelta ' },
      { description: 'Incluye maleta de mano de 22 libras' },
      { description: 'Traslado Aeropuerto - Hotel - Aeropuerto' },
      { description: '3 noches de Alojamiento', disabled: true },
      { description: 'Cortesia Botella de Ron Nacional o Taza diseño exclusivo ', disabled: true },
      { description: 'Precio y disponibilidad sujeto a cambios', disabled: true },
    ],
  },
  {
    name: 'PETEN',
    img: '/Trips/PETEN.jpg',
    description: 'Entre la selva y las ruinas, Petén te roba el corazón.',
    priceMonthly: 'Q2,752',
    href: '#',
    highlights: [
      { description: 'Precio al contado desde Q2,752' },
      { description: 'Boletos aéreos ida y vuelta ' },
      { description: 'Traslado Aeropuerto - Hotel - Aeropuerto' },
      { description: '3 noches de Alojamiento ' },
      { description: 'Desayunos Diarios', disabled: true },
      { description: 'Precio y disponibilidad sujeto a cambios', disabled: true },
    ],
  },
  {
    name: 'CARTAGENA, CO.',
    img: '/Trips/COLOMBIA.jpg',
    description: 'Bogotá te espera con café, historia y magia en el aire.',
    priceMonthly: 'Q2,995',
    href: '#',
    highlights: [
      { description: 'Precio al contado desde Q2,995' },
      { description: 'Boletos aéreos ida y vuelta ' },
      { description: 'Traslado Aeropuerto - Hotel - Aeropuerto' },
      { description: '3 noches de Alojamiento' },
      { description: 'Desayunos Diarios' },
      { description: 'Precio y disponibilidad sujeto a cambios' },
    ],
  },
]

export default function Example() {
  return (
    <div className="bg-white py-16 sm:py-30">
      <div className="mx-auto max-w-4xl px-6 max-lg:text-center lg:max-w-7xl lg:px-8">
        <h1 className="text-5xl font-semibold tracking-tight text-balance text-gray-950 sm:text-6xl lg:text-pretty">
          ¡Elige el mejor viaje en despega!
        </h1>
        <p className="mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-600 max-lg:mx-auto sm:text-xl/8">
          Elige uno de los mejores viajes con los mejores precios, no te pierdas de experiencias magnificas
          con precios excelentes, viaja, cotiza y ¡Despega!.
        </p>
      </div>

      <div className="relative pt-16 sm:pt-24">
        <div className="absolute inset-x-0 top-48 bottom-0 bg-cover bg-center" style={{ backgroundImage: "url('/Trips/Fondo.jpg')" }} />
        <div className="relative mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
            {tiers.map((tier) => (
              <div
                key={tier.name}
                className="grid grid-cols-1 rounded-4xl max-lg:mx-auto max-lg:w-full max-lg:max-w-md"
              >
                <div className="grid grid-cols-1 rounded-4xl p-2 shadow-md shadow-black/5">
                  <div className="rounded-3xl bg-white p-10 pb-9 shadow-2xl ring-1 ring-black/5">
                    <img
                      src={tier.img}
                      alt={tier.name}
                      className="w-full h-48 rounded-2xl object-cover mb-6"
                    />

                    <h2 className="text-sm font-semibold text-indigo-600">
                      {tier.name} <span className="sr-only">plan</span>
                    </h2>
                    <p className="mt-2 text-sm/6 text-pretty text-gray-600">{tier.description}</p>

                    <div className="mt-8 flex items-center gap-4">
                      <div className="text-5xl font-semibold text-gray-950">{tier.priceMonthly}</div>
                      <div className="text-sm text-gray-600">
                        <p>Al contado</p>
                      </div>
                    </div>

                    <div className="mt-8">
                      <a
                        href={`https://wa.me/50239990332?text=${encodeURIComponent(`Hola, estoy interesado en el viaje a ${tier.name}`)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block rounded-md bg-indigo-600 px-3.5 py-2 text-center text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        ¡Despega ya!
                      </a>
                    </div>

                    <div className="mt-8">
                      <h3 className="text-sm/6 font-medium text-gray-950">Empieza comprando con:</h3>
                      <ul className="mt-3 space-y-3">
                        {tier.highlights.map((highlight) => (
                          <li
                            key={highlight.description}
                            data-disabled={highlight.disabled}
                            className="group flex items-start gap-4 text-sm/6 text-gray-600 data-disabled:text-gray-400"
                          >
                            <span className="inline-flex h-6 items-center">
                              <PlusIcon
                                aria-hidden="true"
                                className="size-4 fill-gray-400 group-data-disabled:fill-gray-300"
                              />
                            </span>
                            {highlight.disabled ? <span className="sr-only">Not included:</span> : null}
                            {highlight.description}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-6 flex justify-center">
        <a
          href={`https://wa.me/50239990332?text=${encodeURIComponent(
            'Quiero información sobre más viajes'
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-xl bg-indigo-600 px-8 py-4 text-lg font-semibold text-white shadow-lg transition hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Explorar más viajes
        </a>
      </div>
    </div>
  )
}
